import type React from 'react'

interface DrawingControlsIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string
  height?: number | string
  color?: string
  disabled?: boolean
  active?: boolean
}

const DrawingControlsIcon: React.FC<DrawingControlsIconProps> = ({
  width = 20,
  height = 20,
  color = '#636F7E',
  disabled = false,
  active = false,
  ...props
}) => {
  const stroke = active ? '#2482D8' : color
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 5.33398L10 5.33398M10 5.33398C10 6.43855 10.8954 7.33398 12 7.33398C13.1046 7.33398 14 6.43855 14 5.33398C14 4.22941 13.1046 3.33398 12 3.33398C10.8954 3.33398 10 4.22942 10 5.33398ZM6 10.6673L14 10.6673M6 10.6673C6 11.7719 5.10457 12.6673 4 12.6673C2.89543 12.6673 2 11.7719 2 10.6673C2 9.56275 2.89543 8.66732 4 8.66732C5.10457 8.66732 6 9.56275 6 10.6673Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DrawingControlsIcon
